export default __webpack_public_path__ + "static/media/confirm-orange.ae697864.svg";